let activeList={
  typeList: [
    { text: "全部类型", value: "" },
    { text: "打卡活动", value: "1" },
    { text: "报名活动", value: "2" },
    { text: "线上活动", value: "3" }
  ],
  statueList:[
     { text: "全部状态", value: "" },
     { text: "未开始", value: "0" },
     { text: "进行中", value: "1" },
     { text: "已结束", value: "2" },
  ],
  typeObj:{
    1:'打卡活动',
    2:'报名活动',
    3:'线上活动',
  },
  statueObj:{
    0:'未开始',
    1:'进行中',
    2:'已结束',
  },
  colorObj:{
    0:'linear-gradient(75deg,rgba(79,172,254,1),rgba(0,242,254,1))',
    1:'linear-gradient(103deg,rgba(255,19,86,1),rgba(255,59,142,1),rgba(255,19,86,1))',
    2:'rgba(0,0,0,.5)',
  }
}
export default activeList;